import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { LOGIN } from "@/constants/testIds";
import { LoginForm } from "@/components/auth/LoginForm";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) {
      navigate("/feed");
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16 bg-bbap-bg">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <Logo showText={false} size="h-20" />
        </div>
        <div className="bg-white border border-zinc-200 rounded-sm p-8">
          <h1 className="font-display font-bold uppercase text-2xl text-zinc-950 text-center mb-2">Log In</h1>
          <p className="text-zinc-500 text-sm text-center mb-6">Welcome back to the movement.</p>

          {error && (
            <div data-testid="login-error-message" className="mb-4 p-3 rounded-sm bg-red-50 border border-red-200 text-red-700 text-sm">
              {error}
            </div>
          )}

          <LoginForm email={email} password={password} loading={loading} onEmailChange={setEmail} onPasswordChange={setPassword} onSubmit={handleSubmit} />

          <p className="text-center text-sm text-zinc-500 mt-6">
            Don't have an account?{" "}
            <Link to="/register" data-testid={LOGIN.registerLink} className="text-[#1E3A6E] font-semibold hover:underline">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
